<script>
import Layout from '@layouts/main'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import formRestricoesEstado from '@/src/components/form-restricoes-estado.vue'

import Service from '@/src/services/restricoes-estado'
import moment from 'moment'

import Praga from '@src/services/pragas'
import Cultura from '@src/services/culturas'
import Produto from '@src/services/produto'

/**
 * Dashboard-1 Component
 */
export default {
  components: { Layout, Loading, formRestricoesEstado },
  data() {
    return {
      mostraForm: true,
      restricoesEstadoEdit: {},
      restricoes_estados: [],
      restricoesEstadoFields: [
        {
          key: 'id_item_produto',
          label: 'Produto/Cultura/Alvo',
          class: 'size-col-20',
        },
        {
          key: 'id_estado',
          label: 'Estado',
          class: 'size-col-20',
        },
        {
          key: 'data_restricao',
          label: 'Data Restrição',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
      currentPage: 1,
      perPage: 20,
      showModal: false,
      isLoading: false,
      idProduto: '',
      pragas: [],
      produtos: [],
      culturas: [],
      filter: {
        id_pragas: '',
        id_cultura: '',
        id_produto: '',
      },
    }
  },
  computed: {},

  watch: {
    currentPage() {
      this.listar()
    },
  },
  mounted() {
    this.listar()
    this.handleGet()
  },
  methods: {
    loading(a) {
      a = !this.isLoading ? true : false
      return a
    },
    listar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      if (
        this.filter.id_pragas === '' &&
        this.filter.id_cultura === '' &&
        this.filter.id_produto === ''
      ) {
        Service.listar(token, this.perPage, this.currentPage).then(
          (resposta) => {
            this.restricoes_estados = resposta.data.dados
            this.rows = resposta.headers['x-total-count']
            this.isLoading = this.loading(this.isLoading)
          }
        )
      } else {
        Service.listar(
          token,
          this.perPage,
          this.currentPage,
          JSON.stringify(this.filter)
        ).then((resposta) => {
          this.restricoes_estados = resposta.data.dados
          this.rows = resposta.headers['x-total-count']
          this.isLoading = this.loading(this.isLoading)
        })
      }
    },
    editRegister(item) {
      this.restricoesEstadoEdit = {
        id_estado: item.id_estado ? item.id_estado.id_estado : '',
        id_item_produto: item.id_item_produto
          ? item.id_item_produto.id_item_produto
          : '',
        data_restricao: item.data_restricao,
      }
      this.mostraForm = false
    },
    handleGet() {
      const token = this.$store.state.auth.currentUser.token
      Praga.listar(token).then((response) => {
        this.pragas = response.data.dados
      })
      Produto.listar(token).then((response) => {
        this.produtos = response.data.dados
      })
      Cultura.listar(token).then((response) => {
        this.culturas = response.data.dados
      })
    },
    cadastra() {
      if (this.restricoesEstadoEdit) {
        this.restricoesEstadoEdit = {}
      }
      if (this.mostraForm === true) {
        this.mostraForm = false
      } else {
        this.mostraForm = true
        this.listar()
      }
    },
    modalDelete(id) {
      this.$bvModal.show('modal-delete')
      this.idProduto = id
    },
    Deletar() {
      const token = this.$store.state.auth.currentUser.token
      this.isLoading = this.loading(this.isLoading)
      Service.deletar(token, this.idProduto)
        .then((resposta) => {
          this.listar()
          this.isLoading = this.loading(this.isLoading)
        })
        .catch((err) => {
          this.isLoading = this.loading(this.isLoading)
          this.$bvToast.toast(
            'Ocorreu um erro ao deletar, verifique se o item está sendo utilizado em outro lugar.',
            {
              variant: 'danger',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            }
          )
        })
      this.idProduto = null
      this.$bvModal.hide('modal-delete')
    },
    formatDate(date) {
      return moment.utc(date).format('DD/MM/YYYY')
    },
  },
}
</script>

<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Restrições Estado</div>
            <div class="subTitulo"
              >Visualize, edite e cadastre novas restrições de estado na
              plataforma.</div
            >
          </div>
          <div class="col-md-1 cadastra">
            <button class="btn btn-webreceita" @click="cadastra">
              <span v-if="mostraForm">Novo</span>
              <span v-else>Lista</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>
        <div class="row" v-if="mostraForm">
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Produto" label-for="filter">
              <v-select
                class="style-select"
                label="nome"
                :options="produtos"
                :reduce="(item) => item.id_produto"
                v-model="filter.id_produto"
                :dense="true"
              ></v-select>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group
              id="input-group-1"
              label="Culturas"
              label-for="filter"
            >
              <v-select
                class="style-select"
                label="nome_comum"
                :options="culturas"
                :reduce="(item) => item.id_cultura"
                v-model="filter.id_cultura"
              ></v-select>
            </b-form-group>
          </div>
          <div class="col-md-2">
            <b-form-group id="input-group-1" label="Alvo" label-for="filter">
              <v-select
                class="style-select"
                label="nome_comum"
                :options="pragas"
                :reduce="(item) => item.id_pragas"
                v-model="filter.id_pragas"
              ></v-select>
            </b-form-group>
          </div>

          <div class="col-md-2">
            <button class="btn btn-webreceita" @click.prevent="listar"
              >Filtrar</button
            >
          </div>
        </div>
      </div>
      <div>
        <div v-if="mostraForm">
          <b-table
            striped
            hover            
            responsive="sm"
            borderless
            bordered
            outlined
            small
            :items="restricoes_estados"
            :fields="restricoesEstadoFields"
            :per-page="perPage"
          >
            <template v-slot:cell(actions)="row">
              <div class="btn-group mb-2">
                <button
                  v-b-tooltip.hover
                  title="Editar"
                  type="button"
                  class="btn btn-light"
                  @click="editRegister(row.item)"
                >
                  <i class="uil uil-edit"></i>
                </button>
                <button
                  v-b-tooltip.hover
                  title="Deletar"
                  type="button"
                  class="btn btn-light"
                  @click="modalDelete(row.item.id_restricao_estado)"
                >
                  <i class="uil uil-trash-alt"></i>
                </button>
              </div>
            </template>
            <template v-slot:cell(ativo)="row">
              {{ row.item.ativo ? 'Sim' : 'Não' }}
            </template>
            <template v-slot:cell(data_restricao)="row">
              {{ formatDate(row.item.data_restricao) }}
            </template>
            <template #cell(id_item_produto)="row"
              ><div v-if="row.item.id_item_produto">
                {{
                  row.item.id_item_produto.id_produto
                    ? row.item.id_item_produto.id_produto.nome
                    : 'Não encontrado'
                }}
                -
                {{
                  row.item.id_item_produto.id_produto
                    ? row.item.id_item_produto.id_cultura.nome_comum
                    : 'Não encontrado'
                }}
                -
                {{
                  row.item.id_item_produto.id_produto
                    ? row.item.id_item_produto.id_pragas.nome_comum
                    : 'Não encontrado'
                }}
              </div></template
            >
            <template #cell(id_estado)="row">{{
              row.item.id_estado ? row.item.id_estado.nome : 'Não encontrado'
            }}</template>
          </b-table>
          <b-pagination
            v-model="currentPage"
            size="md"
            :total-rows="rows"
            :per-page="perPage"
          ></b-pagination>
        </div>

        <div v-else>
          <formRestricoesEstado :restricao_estado="restricoesEstadoEdit" />
        </div>
      </div>

      <div class="borda"></div>
    </div>
    <b-modal id="modal-delete" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="$bvModal.hide('modal-delete')"
          >Não</b-button
        >
        <b-button variant="danger" @click="Deletar">Sim</b-button>
      </template>
    </b-modal>
    <b-overlay :show="isLoading" no-wrap>
    </b-overlay>
  </Layout>
</template>
<style lang="scss">
.bloco {
  margin-top: 30px;
  background-color: #fff;
  padding: 40px;
  border-radius: 0.25rem;
  .titulo {
    font-size: 25px;
    color: #008e75;
    margin-bottom: 10px;
    font-weight: bold;
  }
  .subtitulo {
    margin-bottom: 10px;
  }
  .borda {
    margin-top: 15px;
    margin-bottom: 15px;
    border-bottom: solid 1px #edeff4;
  }
  .formulario {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .btn-webreceita {
    margin-top: 30px;
    margin-bottom: 10px;
    background-color: #008e75;
    padding: 5px 30px;
    &.botaoTopo {
      float: right;
    }
  }
  .filterButton {
    // margin-top: 5px;
    // margin-bottom: 10px;
    background-color: #008e74c7;
    padding: 0 20px;
  }
  .cadastra {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>